var _circle, _g, _circle2, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMerchant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2963_11743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2963_11743)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E32227"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2963_11743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2963_11743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#010101"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2963_11743)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5335 37.0457L45.3087 37.0408V37.9692H45.1719V37.0408H44.8153V36.9235H45.6556V36.9382C45.6556 37.0115 45.6165 37.0457 45.5335 37.0457Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3095 37.9896H45.1727C45.1629 37.9896 45.1531 37.9799 45.1531 37.9701V37.0613H44.8161C44.8063 37.0613 44.7965 37.0515 44.7965 37.0417V36.9245C44.7965 36.9147 44.8063 36.9049 44.8161 36.9049H45.6563C45.6661 36.9049 45.6759 36.9147 45.6759 36.9245V36.9391C45.6759 36.9977 45.6514 37.0662 45.5342 37.0662L45.329 37.0613V37.9701C45.329 37.9799 45.3192 37.9896 45.3095 37.9896ZM45.1922 37.9505H45.2899V37.0417C45.2899 37.0368 45.2899 37.0319 45.2948 37.0271C45.2997 37.0222 45.3046 37.0173 45.3095 37.0222L45.5342 37.0271C45.6173 37.0271 45.6368 36.988 45.6368 36.9489H44.8405V37.0222H45.1727C45.1825 37.0222 45.1922 37.0319 45.1922 37.0417V37.9505Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6859 37.9692V37.0994H46.681L46.3537 37.9692H46.2364L45.9091 37.0994H45.9042V37.9692H45.7772V36.9235H45.9677L46.2951 37.803L46.6224 36.9235H46.8178V37.9692H46.6859Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8187 37.9896H46.6868C46.677 37.9896 46.6672 37.9799 46.6672 37.9701V37.2078L46.3742 37.975C46.3693 37.9847 46.3644 37.9896 46.3546 37.9896H46.2423C46.2325 37.9896 46.2276 37.9847 46.2227 37.975L45.9296 37.1932V37.9652C45.9296 37.975 45.9199 37.9848 45.9101 37.9848H45.7831C45.7733 37.9848 45.7635 37.975 45.7635 37.9652V36.9245C45.7635 36.9147 45.7733 36.9049 45.7831 36.9049H45.9736C45.9834 36.9049 45.9883 36.9098 45.9931 36.9196L46.3009 37.7453L46.6086 36.9196C46.6135 36.9098 46.6184 36.9049 46.6282 36.9049H46.8187C46.8284 36.9049 46.8382 36.9147 46.8382 36.9245V37.9701C46.8382 37.9799 46.8284 37.9896 46.8187 37.9896ZM46.7063 37.9505H46.7943V36.9489H46.6379L46.3155 37.8137C46.3107 37.8235 46.3058 37.8284 46.296 37.8284C46.2862 37.8284 46.2813 37.8235 46.2765 37.8137L45.9541 36.9489H45.7977V37.9505H45.8857V37.1004C45.8857 37.0906 45.8954 37.0808 45.9052 37.0808H45.9101C45.9199 37.0808 45.9247 37.0857 45.9296 37.0955L46.252 37.9505H46.34L46.6624 37.0955C46.6721 37.0759 46.7063 37.0808 46.7063 37.1052V37.9505V37.9505Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7931 20.7805C49.7258 24.709 49.7551 31.1783 45.7051 35.1458C41.7724 39.001 35.3335 39.0401 31.3618 34.9309C27.5268 30.9633 27.5854 24.5575 31.6158 20.6535C35.5143 16.8765 41.8506 16.8276 45.7931 20.7805ZM45.3876 21.3034C44.8404 20.7561 43.9464 20.7561 43.3944 21.3034L42.1535 22.5444C39.6815 20.9271 36.3692 21.191 34.1904 23.2823C31.5767 25.7937 31.5474 29.9372 34.0976 32.478C36.6379 35.009 40.6781 34.9602 43.1599 32.4927C45.329 30.3379 45.6465 27.0446 44.1174 24.5624L45.3876 23.292C45.9347 22.7448 45.9347 21.8506 45.3876 21.3034Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3751 26.6438H18.7232C17.9513 26.6438 17.3162 27.279 17.3162 28.051C17.3162 28.8279 17.9513 29.4582 18.7232 29.4582H23.6036C22.9295 32.2922 20.3744 34.3981 17.3162 34.3883C13.8232 34.3737 10.9262 31.5544 10.9213 27.9679C10.9164 24.3669 13.8671 21.4596 17.4872 21.5329C19.4169 21.572 21.1463 22.471 22.2992 23.8636H26.5935C25.0302 20.3504 21.5274 17.9171 17.5263 17.8536C11.9179 17.7657 7.34521 22.2512 7.25239 27.7676C7.15468 33.4795 11.7371 38.009 17.2429 38.0627C22.9099 38.1213 27.4631 33.5284 27.4582 27.9679C27.4631 27.5184 27.4337 27.0787 27.3751 26.6438Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2963_11743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchant);
export default __webpack_public_path__ + "static/media/merchant.a169c1ae43fb7979ee651d7433bca035.svg";
export { ForwardRef as ReactComponent };